import React, { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { Typography } from "@material-tailwind/react";

function MyDropzone({ onDrop }) {
  const onDropCallback = useCallback(
    (acceptedFiles) => {
      onDrop(acceptedFiles);
    },
    [onDrop]
  );

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: onDropCallback,
    multiple: true,
  });

  return (
    <div {...getRootProps({ className: "dropzone" })} style={dropzoneStyle}>
      <input {...getInputProps()} type="file" name="files[]" />
      <Typography variant="h6" color="blue-gray">
        Drag 'n' drop some files here, or click to select files
      </Typography>
    </div>
  );
}

const dropzoneStyle = {
  border: "2px dashed #007bff",
  borderRadius: "4px",
  padding: "30px",
  width: "100%",
  textAlign: "center",
  cursor: "pointer",
};

export default MyDropzone;
